// src/icons/RingOutlineIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function RingOutlineIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        clipRule: "evenodd",
        d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx("path", {
        clipRule: "evenodd",
        d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "currentColor",
        fillRule: "evenodd"
      })
    ]
  });
}
export {
  RingOutlineIcon
};
//# sourceMappingURL=RingOutlineIcon.mjs.map